import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, NgModel, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDate, NgbDatepickerConfig, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { swalDesition, swalError, swalInfo } from 'src/app/shared/config/swalCommon';
import { setDate } from 'src/app/shared/config/dateCommon';
import { PaymentCapacityService, PeticionService, ProcesoService, UserService, ValueService, LogsService, PersonaService } from 'src/app/services/services.index';
import { FGRespuestaCredito } from 'src/app/interfaces/forms/respuesta-credito.interface';
import { Petition } from 'src/app/interfaces/petition';
import { alphanumericMask, deleteForm, loadForm, nameMask, onlyNumberMask, saveForm } from 'src/app/shared';
import { Value } from 'src/app/interfaces/value';
import { User } from 'src/app/interfaces/user';
import { CodeCreditAnswer, CreditAnswer } from 'src/app/interfaces/interfaces.index';
import { GenericService } from 'src/app/services/generic.service';
import { LogsNav } from 'src/app/interfaces/interfaces.index';

@Component({
  selector: 'app-respuesta-credito',
  templateUrl: './respuesta-credito.component.html',
  styleUrls: ['./respuesta-credito.component.css']
})
export class RespuestaCreditoComponent implements OnInit {

  id: number;
  hoy: NgbDate;
  hoy18: NgbDate;
  forma: FGRespuestaCredito;
  respuestaCredito: CreditAnswer;
  resEstudio: string;
  segCredito: string;
  estAprobacion: string;
  motAplazamiento: string;
  respuestaOpc: Value[] = [];
  creditoYoN;
  aprobacionOpc: Value[] = [];
  motivosOpc;
  aplazamientoOpc: Value[] = [];
  D1: boolean = false;
  D2: boolean = false;
  CD1: boolean = false;
  CD2: boolean = false;
  error = false;
  selPetition: Petition;
  formIdentifier = "formSaved";
  formSubmitted = false;
  loadValues = false;
  values: Value[] = [];
  saveForm = saveForm;
  nameMask = nameMask;
  code: CodeCreditAnswer;
  response: any;
  petitions: Petition[] = [];
  user: User;
  tiposIdentidad: Value[] = [];
  onlyNumberMask = onlyNumberMask;
  alphanumericMask = alphanumericMask;
  personType = "Natural"

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private rutaActiva: ActivatedRoute,
    public calendar: NgbCalendar,
    public dpConfig: NgbDatepickerConfig,
    private paymentCapacityService: PaymentCapacityService,
    private SpinnerService: NgxSpinnerService,
    private valueService: ValueService,
    private userService: UserService,
    private peticionService: PeticionService,
    private processService: ProcesoService,
    private genericService: GenericService,
    private logsService: LogsService,
    private personService: PersonaService
  ) {
    this.selPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
    this.formIdentifier = `creditAnswer_${this.selPetition.id}`;
    this.id = this.selPetition.id;
    this.hoy = calendar.getToday();
    this.hoy18 = new NgbDate(this.hoy.year - 18, this.hoy.month, this.hoy.day);
    this.user = this.userService.user;

    this.forma = this.fb.group({
      nombreCliente: [null as string | null],
      nroIdentificacion: [null as string | null],
      nroSolicitud: [this.id],
      respuestaDate: [this.hoy],
      respuestaEstudio: [null as string | null],
      seguroCredito: [null as string | null],
      estructuraAprobacion: [["D1"]],
      nombresD1: [null as string | null],
      apellidosD1: [null as string | null],
      nombresD2: [null as string | null],
      apellidosD2: [null as string | null],
      nombresCD1: [null as string | null],
      apellidosCD1: [null as string | null],
      typeOfIdentityCD1: ["CC"],
      documentNumberCD1: [null as number | null],
      nombresCD2: [null as string | null],
      apellidosCD2: [null as string | null],
      typeOfIdentityCD2: ["CC"],
      documentNumberCD2: [null as number | null],
      motivoAplazamiento: [null as string | null],
      motivoAplazamientoD2: [null as string | null],
      motivoAplazamientoCD1: [null as string | null],
      motivoAplazamientoCD2: [null as string | null],
      pazSalvo: [null as string | null],
      certificacionDesembargo: [null as string | null],
      otros: [null as string | null],
      pazSalvoD2: [null as string | null],
      certificacionDesembargoD2: [null as string | null],
      otrosD2: [null as string | null],
      pazSalvoCD1: [null as string | null],
      certificacionDesembargoCD1: [null as string | null],
      otrosCD1: [null as string | null],
      pazSalvoCD2: [null as string | null],
      certificacionDesembargoCD2: [null as string | null],
      otrosCD2: [null as string | null],
      observaciones: [null as string | null],
      fechaEnvioCarta: [this.hoy],
      usuario: [`${this.user?.name} ${this.user?.lastName}`],
      fechaFirma: [null as NgbDateStruct | null],
      consecutivoPagare: [null as string | null],
      firmasPagare: [null as NgbDateStruct | null]
    });
  }

  ngOnInit(): void {
    this.addLogsNav();
    this.data();

    this.respuestaEstudio.valueChanges.subscribe(x => {
      if(x === '1') {
        this.motivoAplazamiento.setValue(null);
        this.motivoAplazamientoD2.setValue(null);
        this.motivoAplazamientoCD1.setValue(null);
        this.motivoAplazamientoCD2.setValue(null);
        this.motivoAplazamientoD2.setValue(null);
        this.pazSalvo.setValue(null);
        this.certificacionDesembargo.setValue(null);
      }
      if(x === '2' || x === '3') {
        this.nombresD1.setValue(null);
        this.apellidosD1.setValue(null);
        this.nombresD1.clearValidators();
        this.apellidosD1.clearValidators();
        this.nombresD1.updateValueAndValidity();
        this.apellidosD1.updateValueAndValidity();
        this.nombresD2.setValue(null);
        this.apellidosD2.setValue(null);
        this.nombresCD1.setValue(null);
        this.apellidosCD1.setValue(null);
        this.documentNumberCD1.setValue(null);
        this.nombresCD2.setValue(null);
        this.apellidosCD2.setValue(null);
        this.documentNumberCD2.setValue(null);
        if(this.estructuraAprobacion)
          this.estructuraAprobacion.setValue(null);
        this.estructuraAprobada();
      }
      if(x === '3') {
        this.motivoAplazamiento.setValue(null);
        this.pazSalvo.setValue(null);
        this.certificacionDesembargo.setValue(null);
      }
    });

    this.estructuraAprobacion.valueChanges.subscribe(x => {

      if(x){
        if(!x.includes('D1')) this.motivoAplazamiento.setValue(null);
        if(!x.includes('D2')) this.motivoAplazamientoD2.setValue(null);
        if(!x.includes('C1')) this.motivoAplazamientoCD1.setValue(null);
        if(!x.includes('C2')) this.motivoAplazamientoCD2.setValue(null);
      }
    });

    this.motivoAplazamiento.valueChanges.subscribe(x => {
      if(!x || !x.includes('13')) this.pazSalvo.setValue(null);
      if(!x || !x.includes('14')) this.certificacionDesembargo.setValue(null);
      if(!x || !x.includes('17')) this.otros.setValue(null);
    });

    this.motivoAplazamientoD2.valueChanges.subscribe(x => {
      if(!x || !x.includes('13')) this.pazSalvoD2.setValue(null);
      if(!x || !x.includes('14')) this.certificacionDesembargoD2.setValue(null);
      if(!x || !x.includes('17')) this.otrosD2.setValue(null);
    });

    this.motivoAplazamientoCD1.valueChanges.subscribe(x => {
      if(!x || !x.includes('13')) this.pazSalvoCD1.setValue(null);
      if(!x || !x.includes('14')) this.certificacionDesembargoCD1.setValue(null);
      if(!x || !x.includes('17')) this.otrosCD1.setValue(null);
    });

    this.motivoAplazamientoCD2.valueChanges.subscribe(x => {
      if(!x || !x.includes('13')) this.pazSalvoCD2.setValue(null);
      if(!x || !x.includes('14')) this.certificacionDesembargoCD2.setValue(null);
      if(!x || !x.includes('17')) this.otrosCD2.setValue(null);
    });
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  data() {
    this.SpinnerService.show();

    this.personService.getPeopleByUser(this.selPetition.userId).subscribe(res => {
      if (res.lastName.includes(res.surname)) {
        this.forma.patchValue({nombreCliente: `${res.name} ${res.lastName}`});
        this.forma.patchValue({nroIdentificacion: res.documentNumber});
      }else{
        this.forma.patchValue({nombreCliente: `${res.name} ${res.lastName} ${res.surname}`});
        this.forma.patchValue({nroIdentificacion: res.documentNumber});

      }

      if(res.typeOfIdentity.trim() === "N" || res.typeOfIdentity.trim() === "NIT")
        this.personType = "Juridical";
    });

    this.getValues();

    this.creditoYoN = [
      { value: 'S', name: 'Si' },
      { value: 'N', name: 'No' }
    ];

    this.valueService.getValuesByType('motivoaplazamiento').subscribe(data => {
      this.motivosOpc = data;
    }, error => this.handleError(error));

    this.genericService.getCreditAnswerByPetitionId(this.selPetition.id).subscribe(res => {
      if(res !== null) {
        let creditAnswer: any = { ...res };
        creditAnswer.estructuraAprobacion = JSON.parse(res.estructuraAprobacion);
        creditAnswer.motivoAplazamiento = JSON.parse(res.motivoAplazamiento);
        creditAnswer.motivoAplazamientoD2 = JSON.parse(res.motivoAplazamientoD2);
        creditAnswer.motivoAplazamientoCD1 = JSON.parse(res.motivoAplazamientoCD1);
        creditAnswer.motivoAplazamientoCD2 = JSON.parse(res.motivoAplazamientoCD2);
        creditAnswer.respuestaDate = this.hoy;
        creditAnswer.fechaEnvioCarta = this.hoy;
        creditAnswer.observaciones = null;
        this.forma.patchValue(creditAnswer);
      }

      setTimeout(() => {
        loadForm(this.forma, this.formIdentifier);
        this.estructuraAprobada();
        this.respuestaDate.setValue(this.hoy);
        this.fechaEnvioCarta.setValue(this.hoy);
        this.SpinnerService.hide();
      }, 1000)
    });
  }

  validator = (model: NgModel, form: NgForm) => (!model.untouched && model.invalid || model.invalid && form.submitted);

  validarForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validarForm(control);
      }
    });
  }

  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }

  estructuraAprobada() {
    let v1 = 0, v2 = 0, v3 = 0, v4 = 0;
    if (this.estructuraAprobacion.value == null || this.estructuraAprobacion.value.length == 0) {
      this.D1 = false; this.D2 = false; this.CD1 = false; this.CD2 = false;
      return;
    }
    else {
      this.estructuraAprobacion.value.forEach(element => {
        if (element == "D1") { v1++; }
        if (element == "D2") { v2++; }
        if (element == "C1") { v3++; }
        if (element == "C2") { v4++; }
      });
      if (v1 == 1) {  this.D1 = true; }
      else {
        this.D1 = false;
        this.nombresD1.setValue(null);
        this.apellidosD1.setValue(null);
      }
      if (v2 == 1) {  this.D2 = true; }
      else {
        this.D2 = false;
        this.nombresD2.setValue(null);
        this.apellidosD2.setValue(null);
      }
      if (v3 == 1) { this.CD1 = true; }
      else {
        this.CD1 = false;
        this.nombresCD1.setValue(null);
        this.apellidosCD1.setValue(null);
        this.documentNumberCD1.setValue(null);
      }
      if (v4 == 1) { this.CD2 = true; }
      else {
        this.CD2 = false;
        this.nombresCD2.setValue(null);
        this.apellidosCD2.setValue(null);
        this.documentNumberCD2.setValue(null);
      }
    }
    const control = this.forma.get('estructuraAprobacion');

  }

  datosForm = (): any => {
    this.respuestaCredito = {
      petitionId: this.selPetition.id,
      nombreCliente: this.nombreCliente.value,
      nroIdentificacion: this.nroIdentificacion.value,
      nroSolicitud: this.nroSolicitud.value,
      respuestaDate: setDate(this.respuestaDate.value),
      respuestaEstudio: this.respuestaEstudio.value,
      seguroCredito: this.seguroCredito.value,
      estructuraAprobacion: this.estructuraAprobacion.value ? JSON.stringify(this.estructuraAprobacion.value) : null,
      nombresD1: this.nombresD1.value,
      apellidosD1: this.personType === "Natural" ? this.apellidosD1.value : " ",
      nombresD2: this.nombresD2.value,
      apellidosD2: this.apellidosD2.value,
      nombresCD1: this.nombresCD1.value,
      apellidosCD1: this.apellidosCD1.value,
      typeDocumentCD1: this.documentNumberCD1.value ? this.typeOfIdentityCD1.value : null,
      documentNumberCD1: Number(this.documentNumberCD1.value),
      nombresCD2: this.nombresCD2.value,
      apellidosCD2: this.apellidosCD2.value,
      typeDocumentCD2: this.documentNumberCD2.value ? this.typeOfIdentityCD2.value : null,
      documentNumberCD2: Number(this.documentNumberCD2.value),
      motivoAplazamiento: this.motivoAplazamiento.value ? JSON.stringify(this.motivoAplazamiento.value) : null,
      motivoAplazamientoD2: this.motivoAplazamientoD2.value ? JSON.stringify(this.motivoAplazamientoD2.value) : null,
      motivoAplazamientoCD1: this.motivoAplazamientoCD1.value ? JSON.stringify(this.motivoAplazamientoCD1.value) : null,
      motivoAplazamientoCD2: this.motivoAplazamientoCD2.value ? JSON.stringify(this.motivoAplazamientoCD2.value) : null,
      pazSalvo: this.pazSalvo.value,
      certificacionDesembargo: this.certificacionDesembargo.value,
      otros: this.otros.value,
      pazSalvoD2: this.pazSalvoD2.value,
      certificacionDesembargoD2: this.certificacionDesembargoD2.value,
      otrosD2: this.otrosD2.value,
      pazSalvoCD1: this.pazSalvoCD1.value,
      certificacionDesembargoCD1: this.certificacionDesembargoCD1.value,
      otrosCD1: this.otrosCD1.value,
      pazSalvoCD2: this.pazSalvoCD2.value,
      certificacionDesembargoCD2: this.certificacionDesembargoCD2.value,
      otrosCD2: this.otrosCD2.value,
      observaciones: this.observaciones.value,
      fechaEnvioCarta: setDate(this.fechaEnvioCarta.value),
      usuario: this.usuario.value,
      fechaFirma: new Date(),
      consecutivoPagare: this.consecutivoPagare.value,
      firmasPagare: "firmasPagare"
    };
    return this.respuestaCredito;
  }

  registrar() {


    const estructuraAprobacion = this.forma.get('estructuraAprobacion').value;
    if (!estructuraAprobacion.includes('D1') && this.respuestaEstudio.value=="1") {
        alert('Debe seleccionar al menos el Deudor.');
        return;
    }
    this.formSubmitted = true;
    saveForm(this.forma, this.formIdentifier);


    if (this.forma.invalid) {
      this.error = true;
      this.validarForm(this.forma);
      Swal.fire(swalInfo('Faltan campos requeridos, verifique'));
      this.formSubmitted = false;
      return;
    }

    const codigo = Number(this.respuestaEstudio.value);

    this.code = {
      petitionId: this.selPetition.id,
      codigo,
      nombreD2: this.nombresD2.value,
      typeDocumentCD1: this.documentNumberCD1.value ? this.typeOfIdentityCD1.value : null,
      documentNumberCD1: Number(this.documentNumberCD1.value),
      typeDocumentCD2: this.documentNumberCD2.value ? this.typeOfIdentityCD2.value : null,
      documentNumberCD2: Number(this.documentNumberCD2.value),
      reason: this.getReason(),
      reasonCD1: this.getReasonCD1(),
      reasonD2: this.getReasonD2(),
      reasonCD2: this.getReasonCD2(),
      approvalStructure: this.getApprovalStructure(),
      pazSalvo: this.pazSalvo.value,
      certificacionDesembargo: this.certificacionDesembargo.value,
      otros: this.otros.value,
      pazSalvoD2: this.pazSalvoD2.value,
      certificacionDesembargoD2: this.certificacionDesembargoD2.value,
      otrosD2: this.otrosD2.value,
      pazSalvoCD1: this.pazSalvoCD1.value,
      certificacionDesembargoCD1: this.certificacionDesembargoCD1.value,
      otrosCD1: this.otrosCD1.value,
      pazSalvoCD2: this.pazSalvoCD2.value,
      certificacionDesembargoCD2: this.certificacionDesembargoCD2.value,
      otrosCD2: this.otrosCD2.value,
      observaciones: this.observaciones.value
    };

    if(codigo == 1)
    {
      if(this.selPetition?.secondHolder)
      {

      }

      if (this.selPetition?.coDebtors)
      {

      }
    }

    const logNav: LogsNav = {
      logType: 'Log de Proceso',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: this.selPetition.id,
      stepCompleted: 'Respuesta de Crédito',
      reasonException: ''
    };
    sessionStorage.setItem("logNav", JSON.stringify(logNav));

    this.SpinnerService.show();

    this.userService.sendCodePost(this.code).subscribe(
      data => {
        this.response = data;

        const messagesArray = this.response.mensajeValidacion?.split(",");
        const error = messagesArray ? messagesArray[0].trim() : "Error desconocido";
        const message = messagesArray ? messagesArray[1]?.trim() : null;

        if(error === '' || error === null) {
          if (codigo === 1 && message === "Generacion exitosa") {
            this.sendCreditAnswer(message);
          }
          else if (codigo === 2 && message === "Aplazado"){
            this.sendCreditAnswer(message);
          }
          else if (codigo === 3 && message === "Rechazado"){
            this.processService.petitionPostponed(this.selPetition.id).subscribe(() => {
              this.sendCreditAnswer(message);
            }, error => {
              this.SpinnerService.hide();
              this.formSubmitted = false;
              this.handleError(error);
            });
          }
        }
        else {
          this.SpinnerService.hide();
          this.formSubmitted = false;
          Swal.fire({icon: 'warning', title: 'SICO', text: error});
        }
      }, error => {
        this.SpinnerService.hide();
        this.formSubmitted = false;
        this.handleError(error);
      }
    );
  }

  onSave() {
    Swal.fire(swalDesition('Guardar información', '¿Desea guardar la información diligenciada para reanudar este formulario en otro momento?')).then(res => {
      if (res.value) {
        saveForm(this.forma, this.formIdentifier);
        this.router.navigate([`solicitudes/inicio/usuario`]);
      }
    });
  }

  getValues = () => {
    this.loadValues = true;
    const types = ['estudio', 'aprobacion', 'aplazamiento', 'tipoident'];

    this.valueService.getValuesGroup(types).subscribe(data => {
      const buscar = (type: string) => this.values.filter(x => x.type === type);
      const ordenar = (values: Value[], orderName = true) => values.sort((a, b) => orderName ? a.name.localeCompare(b.name) : parseInt(a.valueId, 0) - parseInt(b.valueId, 0));
      this.values = data;
      this.respuestaOpc = ordenar(buscar('estudio'));
      this.aprobacionOpc = ordenar(buscar('aprobacion'));
      this.aplazamientoOpc = ordenar(buscar('aplazamiento'));
      this.tiposIdentidad = ordenar(buscar('tipoident'));
      this.loadValues = false;
    }, error => this.handleError(error.error));
  }

  onBack() {
    this.router.navigate(['/solicitudes/inicio/usuario']);
  }

  NgbDateToDate = (date) => {
    const fecha = Object.values(date);
    let stringDate = '';
    fecha.map((val, index) => {
      if (index == 0) {
        stringDate += `${val}`;
      } else {
        stringDate += `-${val}`;
      }
    });
    return new Date(stringDate);
  };

  sendCreditAnswer(messageSico: string) {
    this.genericService.createCreditAnswer(this.datosForm()).subscribe(res => {

      const logNav = (JSON.parse(sessionStorage.getItem('logNav')))
      logNav.reasonException = messageSico;
      this.logsService.addLogNavAsync(logNav).subscribe();

      this.SpinnerService.hide();
      this.formSubmitted = false;
      deleteForm(this.formIdentifier);
      Swal.fire({icon: 'success', title: 'SICO', text: messageSico}).then(() => {
        this.router.navigate([`solicitudes/inicio/usuario`]);
      });
    }, error =>  {
      const logNav: LogsNav = {
        logType: 'Log de Proceso',
        visitedPage: location.href,
        userId: this.userService.user.id,
        petitionId: this.selPetition.id,
        stepCompleted: 'Respuesta de Crédito',
        reasonException: error.error.userMessage
      };
      this.logsService.addLogNavAsync(logNav).subscribe();
      this.formSubmitted = false;
      this.handleError(error)
    });
  }

  dateToNgbdate(date: string): NgbDate {
    const auxDate = date.substring(0, 10);
    const values = auxDate.split('-');

    return new NgbDate(Number(values[0]), Number(values[1]), Number(values[2]));
  }

  getApprovalStructure(): string {
    if(this.respuestaEstudio.value === '1') {
      const approvalStructure = [ this.estructuraAprobacion.value]

      let apprStructureDto = [];

      approvalStructure.forEach(r => {
      if(r?.length > 0) apprStructureDto = apprStructureDto.concat(r);
      })

      return JSON.stringify(apprStructureDto);
    }
    else if(this.respuestaEstudio.value === '3') {
      return this.observaciones.value;
    }

    return null;
  }

  getReason(): string {
    if(this.respuestaEstudio.value === '1')
    {
      return this.observaciones.value;
    }
    else if(this.respuestaEstudio.value === '2') {
      const reasons = [ this.motivoAplazamiento.value]

      let reasonsDto = [];

      reasons.forEach(r => {
      if(r?.length > 0) reasonsDto = reasonsDto.concat(r);
      })

      return JSON.stringify(reasonsDto);
    }
    else if(this.respuestaEstudio.value === '3') {
      return this.observaciones.value;
    }

    return null;
  }

  getReasonD2(): string {
    if(this.respuestaEstudio.value === '2') {
      const reasons = [ this.motivoAplazamientoD2.value ]

      let reasonsDto = [];

      reasons.forEach(r => {
      if(r?.length > 0) reasonsDto = reasonsDto.concat(r);
      })

      return JSON.stringify(reasonsDto);
    }
    else if(this.respuestaEstudio.value === '3') {
      return this.observaciones.value;
    }

    return null;
  }

  getReasonCD1(): string {
    if(this.respuestaEstudio.value === '2') {
      const reasons = [ this.motivoAplazamientoCD1.value ]

      let reasonsDto = [];

      reasons.forEach(r => {
      if(r?.length > 0) reasonsDto = reasonsDto.concat(r);
      })

      return JSON.stringify(reasonsDto);
    }
    else if(this.respuestaEstudio.value === '3') {
      return this.observaciones.value;
    }

    return null;
  }

  getReasonCD2(): string {
    if(this.respuestaEstudio.value === '2') {
      const reasons = [ this.motivoAplazamientoCD2.value ]

      let reasonsDto = [];

      reasons.forEach(r => {
      if(r?.length > 0) reasonsDto = reasonsDto.concat(r);
      })

      return JSON.stringify(reasonsDto);
    }
    else if(this.respuestaEstudio.value === '3') {
      return this.observaciones.value;
    }

    return null;
  }

  get nombreCliente() { return this.forma.get('nombreCliente');}
  get nroIdentificacion() { return this.forma.get('nroIdentificacion');}
  get nroSolicitud() { return this.forma.get('nroSolicitud');}
  get respuestaDate() { return this.forma.get('respuestaDate');}
  get respuestaEstudio() { return this.forma.get('respuestaEstudio');}
  get seguroCredito() { return this.forma.get('seguroCredito');}
  get estructuraAprobacion() { return this.forma.get('estructuraAprobacion'); }
  get nombresD1() { return this.forma.get('nombresD1');}
  get apellidosD1() { return this.forma.get('apellidosD1');}
  get nombresD2() { return this.forma.get('nombresD2');}
  get apellidosD2() { return this.forma.get('apellidosD2');}
  get nombresCD1() { return this.forma.get('nombresCD1');}
  get apellidosCD1() { return this.forma.get('apellidosCD1');}
  get typeOfIdentityCD1() { return this.forma.get('typeOfIdentityCD1');}
  get documentNumberCD1() { return this.forma.get('documentNumberCD1');}
  get nombresCD2() { return this.forma.get('nombresCD2');}
  get apellidosCD2() { return this.forma.get('apellidosCD2');}
  get typeOfIdentityCD2() { return this.forma.get('typeOfIdentityCD2');}
  get documentNumberCD2() { return this.forma.get('documentNumberCD2');}
  get motivoAplazamiento() {return this.forma.get('motivoAplazamiento');}
  get motivoAplazamientoD2() {return this.forma.get('motivoAplazamientoD2');}
  get motivoAplazamientoCD1() {return this.forma.get('motivoAplazamientoCD1');}
  get motivoAplazamientoCD2() {return this.forma.get('motivoAplazamientoCD2');}
  get pazSalvo() {return this.forma.get('pazSalvo');}
  get certificacionDesembargo() {return this.forma.get('certificacionDesembargo');}
  get otros() {return this.forma.get('otros');}
  get pazSalvoD2() {return this.forma.get('pazSalvoD2');}
  get certificacionDesembargoD2() {return this.forma.get('certificacionDesembargoD2');}
  get otrosD2() {return this.forma.get('otrosD2');}
  get pazSalvoCD1() {return this.forma.get('pazSalvoCD1');}
  get certificacionDesembargoCD1() {return this.forma.get('certificacionDesembargoCD1');}
  get otrosCD1() {return this.forma.get('otrosCD1');}
  get pazSalvoCD2() {return this.forma.get('pazSalvoCD2');}
  get certificacionDesembargoCD2() {return this.forma.get('certificacionDesembargoCD2');}
  get otrosCD2() {return this.forma.get('otrosCD2');}
  get observaciones() {return this.forma.get('observaciones');}
  get fechaEnvioCarta() {return this.forma.get('fechaEnvioCarta');}
  get usuario() {return this.forma.get('usuario');}
  get fechaFirma() {return this.forma.get('fechaFirma');}
  get consecutivoPagare() {return this.forma.get('consecutivoPagare');}
  get firmasPagare() {return this.forma.get('firmasPagare');}


  onClear() {
    const control = this.forma.get('estructuraAprobacion');
    if(this.respuestaEstudio.value=="1")
      control.setValue(["D1"], { emitEvent: false });
  }
}
